import React from 'react';
import type { KeenSliderOptions } from 'keen-slider/react';
import { useKeenSlider } from 'keen-slider/react';
import { useMediaQuery } from '@context/mediaQuery';

const MOBILE_CARD_WIDTH = 254;
const CAROUSEL_SLIDES_SPACE = 0.15;

/**
 * @param slides - Array of slides to be rendered
 */
export const Carousel = ({
  slides,
}: {
  /** Array of slides to be rendered. Must be MEMOIZED!*/
  slides: { id: string; slide: React.ReactNode }[];
}) => {
  const { windowSize } = useMediaQuery();

  const slidesPerView = windowSize.width / MOBILE_CARD_WIDTH - CAROUSEL_SLIDES_SPACE;

  const options: KeenSliderOptions = React.useMemo(() => {
    return {
      mode: 'snap',
      initial: 0,
      slides: {
        origin: 'auto',
        perView: slidesPerView,
        spacing: -6,
      },
    };
  }, [slidesPerView]);

  const [sliderRef] = useKeenSlider<HTMLDivElement>(options);

  return (
    <div>
      <div ref={sliderRef} className="keen-slider" aria-label="carousel">
        {slides &&
          slides?.map(({ id, slide }) => (
            <div key={id} className="keen-slider__slide">
              {slide}
            </div>
          ))}
      </div>
    </div>
  );
};
